import httpClient from './httpClient'

export default {
  async getInvoices() {
    let ret = await httpClient.get('stripe/invoices')
    return ret
  },
  async downloadNfe(invoiceId) {
    let ret = await httpClient.get(
      `stripe/invoices?invoice_id=${invoiceId}&download_nfe=1`
    )
    return ret
  },
}
